export default "__VITE_ASSET__oSm8oly8__"